import React from "react";
import styled, { css } from "styled-components";
import Button from "../atoms/Button";
import ChevronLeft from "../atoms/icons/ChevronLeft";
import { getAppThemeName } from "../../Services/appTheme";
const Container = styled.div `
    border-radius: 0 0 10px 10px;
    box-shadow: ${(props) => props.appTheme === "invoned"
    ? "none"
    : "0 5px 20px rgba(26, 26, 33, 0.11)"};
    background-color: ${(props) => props.appTheme === "invoned" ? "white" : props.theme.primary};
    padding: 30px;
    margin-bottom: 30px;
`;
const ButtonContainer = styled.div `
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: 500px) {
        flex-direction: column-reverse;
        flex-wrap: wrap;
    }
`;
const StyledNextButton = styled(Button) `
    flex-basis: 50%;
    margin-left: auto;

    @media only screen and (max-width: 500px) {
        flex-basis: 100%;
        width: 100%;
    }
`;
const StyledPreviousButton = styled(Button) `
    @media only screen and (max-width: 500px) {
        align-items: flex-start;
        align-self: flex-start;
    }

    ${(props) => props.appTheme === "invoned" &&
    css `
            color: ${(props) => props.theme.textBase};

            svg {
                fill: ${(props) => props.theme.textBase};
            }

            &:hover,
            &:focus {
                color: ${(props) => props.theme.textDark};

                svg {
                    fill: ${(props) => props.theme.textDark};
                }
            }
        `};
`;
const FormActions = ({ backButtonHandle, nextButtonText, nextButtonIcon, buttonFullWidth, hasNextButtonIconLeft, hasNextButtonIconRight, loading, }) => (React.createElement(Container, { appTheme: getAppThemeName() },
    React.createElement(ButtonContainer, null,
        backButtonHandle && (React.createElement(StyledPreviousButton, { type: "button", onClick: backButtonHandle, hasIconLeft: true, transparent: true, buttonIcon: React.createElement(ChevronLeft, null), appTheme: getAppThemeName() }, "Terug")),
        React.createElement(StyledNextButton, { loading: loading, disabled: loading, type: "submit", hasIconLeft: hasNextButtonIconLeft, hasIconRight: hasNextButtonIconRight, fullWidth: buttonFullWidth, buttonIcon: nextButtonIcon }, nextButtonText))));
export default FormActions;
